import Trans from 'next-translate/Trans'
import Link from 'next/link'
import { blueLink } from '../stateless/typo/link-style'
import { routeParseAbsolute } from '@app/lib/router-handler'
import { Translate } from 'next-translate'
import { Header2, Header3, Header4 } from '../general/header'
import { classNames } from '@app/utils'
import { companyName } from '@app/configs'
import { FILTERED_MARKETING } from '@app/configs/app-config'

const FAQItem = ({
  t,
  index,
  lang,
  blockIndex,
  headers,
}: {
  t: Translate
  index: number
  lang: string
  blockIndex?: number[]
  headers?: 'h2' | 'h3' | 'h4'
}) => {
  if (
    (blockIndex && blockIndex?.includes(index)) ||
    ((!index || index === 5) && FILTERED_MARKETING)
  ) {
    return null
  }

  const Head = headers === 'h3' ? Header3 : headers === 'h4' ? Header4 : Header2

  const r = `faq:questions.${index}.header`
  const faqText = t(r)

  if (faqText === r) {
    return null
  }

  return (
    <details
      itemScope
      itemProp='mainEntity'
      itemType='https://schema.org/Question'
      open={!index}
    >
      <summary className='cursor-pointer'>
        <Head
          itemProp='name'
          head3
          className={classNames(
            'inline px-1',
            blockIndex ? 'md:text-lg lg:text-lg xl:text-lg' : ''
          )}
        >
          {faqText}
        </Head>
      </summary>
      <div
        itemScope
        itemProp='acceptedAnswer'
        itemType='https://schema.org/Answer'
        className='px-5 py-2'
      >
        <Trans
          i18nKey={`faq:questions.${index}.details`}
          values={{ companyName: companyName }}
          components={[
            <p className='text-base' itemProp='text' key={'q-1'} />,
            <strong key={'q21'} />,
            <Link
              key={'q23'}
              rel='noopener'
              target='_blank'
              className={blueLink}
              href={routeParseAbsolute('/', lang)}
            />,
          ]}
        />
      </div>
    </details>
  )
}

export const FaqSection = ({
  t,
  lang,
  blockIndex,
  headers,
}: {
  t: Translate
  lang: string
  blockIndex?: number[]
  headers?: 'h2' | 'h3' | 'h4'
}) => {
  return (
    <div className='space-y-6 py-6'>
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <FAQItem
          index={i}
          t={t}
          lang={lang}
          key={`faq-${i}`}
          blockIndex={blockIndex}
          headers={headers}
        />
      ))}
    </div>
  )
}
